import { Component, effect, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import DateBox from 'devextreme/ui/date_box';
import ruMessages from 'devextreme/localization/messages/ru.json';
import ukMessages from '../assets/i18n/devexpress-uk.json';
import { locale, loadMessages } from 'devextreme/localization';
import { AppConstants } from './core/constants/app-constants';
import { Title } from '@angular/platform-browser';
import { AuthService } from './core/services/auth-service';
import { UserFacade } from './store/user/facade';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  private userFacade = inject(UserFacade);
  protected translate = inject(TranslateService);
  public authService = inject(AuthService);
  private titleService = inject(Title);

  constructor() {
    this.translate.setDefaultLang(AppConstants.DEFAULT_LANGUAGE);
    this.translate.use(AppConstants.DEFAULT_LANGUAGE);

    loadMessages(ruMessages);
    loadMessages(ukMessages);

    locale(AppConstants.DEFAULT_LANGUAGE);

    DateBox.defaultOptions({
      device: { deviceType: 'desktop' },
      options: {
        displayFormat: 'dd-MM-yyyy',
        type: 'date',
        pickerType: 'calendar',
        useMaskBehavior: 'true',
      },
    });

    effect(() => {
      this.userFacade.setSelected(this.authService.user());
    });

    this.userFacade
      .selected()
      .pipe(takeUntilDestroyed())
      .subscribe(u => {
        if (u?.language) {
          locale(u.language);
          this.translate.use(u.language);
        }
      });
  }

  toggleMenu() {
    let infoPanel = document.querySelector('.app-info-panel'),
      navOverlay = document.querySelector('.nav-overlay'),
      burger = document.querySelector('.ic.menu');
    infoPanel.classList.toggle('app-info-panel_active');
    navOverlay.classList.toggle('nav-overlay_active');
    burger.classList.toggle('menu_active');
  }

  public ngOnInit(): void {
    // Page title
    this.translate.get('TITLE_MAIN').subscribe(value => {
      this.titleService.setTitle(value);
    });
  }
}
